async function getLoanTermsUpdateEmailTemplate(
  user,
  loanID,
  modifiedCalcAnswers
) {
  try {
    const token = await user.getIdToken();
    const targetUrl = `${process.env.CMS_URL}/loans/getemailtemplate`;

    const response = await fetch(targetUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        loanID: loanID,
        templateID: "loanTermsUpdateEmail",
        modifiedCalcAnswers: modifiedCalcAnswers,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching loan update email template:", error);
    throw error;
  }
}

export default getLoanTermsUpdateEmailTemplate;
